import { EnvironmentVariableEntity } from "../../../domain/entity/EnvironmentVariables";

const ENVIRONMENT_PREFIX_FOR_TESTING: string[] = ["DEV"]

export const isEnvironmentForTesting = (environmentVariable: EnvironmentVariableEntity) => {
    return ENVIRONMENT_PREFIX_FOR_TESTING?.some(item => environmentVariable.env?.includes(item));
}